import {
    formationWithOptionBundles,
    formationWithOptionsMapping,
    masterMapping,
} from '../../constants';
import { formationWithOptionSlugType, fundingKindType, masterSlugType } from '../../types';

const formationContinuePricesHandler = {
    computeFormationWithOptionsPrice,
    computeMasterPrice,
    computeDiscountPrice,
};

function computeFormationWithOptionsPrice(
    formationWithOptionsSlug: formationWithOptionSlugType,
    { fundingKind }: { fundingKind: fundingKindType },
): number {
    const formationWithOptions = formationWithOptionsMapping[formationWithOptionsSlug];
    const priceKey = fundingKind === 'auto' ? 'auto' : 'other';
    const price = formationWithOptions.prices[priceKey];
    return price;
}

function computeMasterPrice(masterSlug: masterSlugType): number {
    const masterInfo = masterMapping[masterSlug];
    return masterInfo.price;
}

function computeDiscountPrice(
    formationsWithOptionsSlug: formationWithOptionSlugType[],
    { fundingKind }: { fundingKind: fundingKindType },
) {
    for (const bundle of formationWithOptionBundles) {
        const hasAllOptions = bundle.options.every((option) =>
            formationsWithOptionsSlug.includes(option),
        );
        if (hasAllOptions) {
            const priceKey = fundingKind === 'auto' ? 'auto' : 'other';
            const initialPrice = bundle.options.reduce((sum, option) => {
                const formationPrice = formationWithOptionsMapping[option].prices[priceKey];
                return sum + formationPrice;
            }, 0);
            return initialPrice - bundle.prices[priceKey];
        }
    }
    return 0;
}

export { formationContinuePricesHandler };
